import {getBaseUrl} from './environment-functions';

export const environment = {
  production: true,
  baseUrl: getBaseUrl()
};
